import React from 'react';
import { TableActionButton, TableActions } from '@/components/ui';
import { FilePen, Archive, Trash2 } from 'lucide-react';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function TableActionButtonsSection() {
  return (
    <SectionWrapper title="Table Action Buttons">
        {/* Variants */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Variants</h3>
          <div className="flex flex-wrap gap-3">
            <TableActions>
              <TableActionButton icon={FilePen}>Edit</TableActionButton>
              <TableActionButton variant="destructive" icon={Archive}>Archive</TableActionButton>
              <TableActionButton variant="destructive" icon={Trash2}>Delete</TableActionButton>
            </TableActions>
          </div>
          <CodeBlock>
{`import { TableActionButton, TableActions } from '@/components/ui';
import { FilePen, Archive, Trash2 } from 'lucide-react';

<TableActions>
  <TableActionButton icon={FilePen}>Edit</TableActionButton>
  <TableActionButton variant="destructive" icon={Archive}>Archive</TableActionButton>
  <TableActionButton variant="destructive" icon={Trash2}>Delete</TableActionButton>
</TableActions>`}
          </CodeBlock>
        </div>

        {/* Usage in Tables */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Usage in Table Columns</h3>
          <p className="text-sm text-muted-foreground mb-4">
            TableActionButton should be used within TableActions wrapper for consistent spacing and alignment in table action columns.
          </p>
          <CodeBlock>
{`columns={[
  { key: 'name', title: 'Name' },
  { key: 'email', title: 'Email' },
  {
    key: 'actions',
    title: 'Actions',
    align: 'right',
    render: (_, record) => (
      <TableActions>
        <TableActionButton icon={FilePen} onClick={() => handleEdit(record)}>
          Edit
        </TableActionButton>
        <TableActionButton
          variant="destructive"
          icon={Archive}
          onClick={() => handleArchive(record)}
        >
          Archive
        </TableActionButton>
      </TableActions>
    )
  }
]}`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
